import { Store } from 'vuex'
import { Context } from '@nuxt/types'

interface UserLevel {
  name: string
}

export default async function (
  store: Store<unknown>,
  routePath: string,
  redirect: Context['redirect']
): Promise<void> {
  if (store.getters['auth/isLoggedIn'] || routePath.includes('login')) return
  try {
    await store.dispatch('nuxtClientInit')
    const user = await store.dispatch('auth/getUser')
    await store.dispatch('auth/getUserSubjects')
    setLevelClass(user.levels)

    if (!store.getters['auth/hasCompletedOnboarding'] && !routePath.includes('onboarding/stap-1')) {
      return redirect('/mijnexamenbundel/onboarding/stap-1')
    }
    if (routePath.includes('onboarding')) {
      return redirect('/mijnexamenbundel/account/profile')
    }
    if (routePath.includes('login')) {
      return redirect('/mijnexamenbundel')
    }
  } catch (e) {
    // redirect to login (preserve the originating path as ?from= unless we're already on login)
    if (routePath.includes('login')) {
      return redirect({ path: '/mijnexamenbundel/login' })
    }
    return redirect({ path: '/mijnexamenbundel/login', query: { from: routePath } })
  }
}

function setLevelClass (levelArray: UserLevel[] = []): void {
  // Levels key has changed to an array with levels because a teacher can choose multiple levels
  // In this case, we selected the first level from the array and return that classname.
  const levelClass = !levelArray.length ? 'user-level-havo' : `user-level-${levelArray[0].name.split('-')[0]}`
  document.documentElement.classList.add(levelClass)
}
